import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatTabGroup } from '@angular/material/tabs';
///////////////////////////////////////////////////////////////////////////////////////////////
import * as cnpj from '@fnando/cnpj';
import { Estados } from 'app/shared/inmemory-db/estados';
///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { Cadastro } from 'app/shared/interfaces/cadastro';
import { CadastroGrupo } from 'app/shared/interfaces/cadastro-grupo';
import { MovtoDetails } from 'app/shared/interfaces/movto-details';
import { Cidade } from 'app/shared/interfaces/cidade';
import { Endereco } from 'app/shared/interfaces/endereco';
import { Estado } from 'app/shared/interfaces/estado';
import { FatDoctoC } from 'app/shared/interfaces/fat-docto-c';
import { PageResult } from 'app/shared/interfaces/page-result';
import { AppConfirmService } from 'app/shared/services/app-confirm/app-confirm.service';
import { AppLoaderService } from 'app/shared/services/app-loader/app-loader.service';
import { CadastroContatoService } from 'app/shared/services/cadastro-contato.service';
import { CadastroGrupoService } from 'app/shared/services/cadastro-grupo.service';
import { CadastroService } from 'app/shared/services/cadastro.service';
import { CepService } from 'app/shared/services/cep.service';
import { CidadeService } from 'app/shared/services/cidade.service';
import { CondpgService } from 'app/shared/services/condpg.service';
import { EstadoService } from 'app/shared/services/estado.service';
import { FatDoctoCService } from 'app/shared/services/fat-docto-c.service';
import { FinancRpService } from 'app/shared/services/financ-rp.service';
import { MarcaService } from 'app/shared/services/marca.service';
import { PortadorService } from 'app/shared/services/portador.service';
import { ReceitaWsService } from 'app/shared/services/receita-ws.service';
import { SerieNFService } from 'app/shared/services/serieNF.service';
import { TabelaMedidaService } from 'app/shared/services/tabela-medida.service';
import { VeiculoService } from 'app/shared/services/veiculo.service';
import { LayoutService } from 'app/shared/services/layout.service';
import * as moment from 'moment';
import { BehaviorSubject, Observable, of, Subscription, timer } from 'rxjs';
import { catchError, debounceTime, finalize, switchMap, tap } from 'rxjs/operators';
import { Validacoes } from '../../../../../utils/validacoes';
//////////////////////////////
import { CadastroGrupoTablePopupComponent } from '../../../cadastros/cadastro-grupo-table/cadastro-grupo-table-popup/cadastro-grupo-table-popup.component';
import { EnderecoPopupComponent } from '../endereco-popup/endereco-popup.component';





@Component({
  selector: 'app-cadastro-table-popup',
  templateUrl: './cadastro-table-popup.component.html',
  styleUrls: ['./cadastro-table-popup.component.scss']
})
export class CadastroTablePopupComponent implements OnInit {
  layoutConf: any;
  public itemForm: FormGroup;
  public itemDiretivasFatForm: FormGroup;

  filtroCidades: Cidade[] = [];
  cidades: Cidade[];
  estados: Estado[];
  ///////////////////////
  grupos: CadastroGrupo[];
  cadMun: Cidade;
  grupo: CadastroGrupo;
  //////////////////////
  cep: any;
  isLoading = false;
  /////////////////////
  isLoadingGrupo = false;
  //////////////////////
  isLoadingCep = false;
  selectedTabIndex = 0;
  errorMsg: string;

  countDown: Subscription;

  counter = 20;
  tick = 750;

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;

  @ViewChild(MatPaginator, { static: false }) paginatorEndereco: MatPaginator;


  pageObject$: BehaviorSubject<PageResult<FatDoctoC>> = new BehaviorSubject<PageResult<FatDoctoC>>(null);
  public movtos: FatDoctoC[];
  page = 1;
  length = 0;
  pageSize = 5;
  pageEvent = null;
  pageSizeOptions: number[] = [5, 10, 25];

  selectedOrdem = 'NENHUM';
  selectedDirect = 'ASC';

  dataFinal = moment(new Date(), 'DD/MM/YYYY').toDate().toISOString().split('T')[0];
  dataInicial = moment(new Date(new Date().setDate(new Date().getDate() - 30)), 'DD/MM/YYYY').toDate().toISOString().split('T')[0];

  pageObjectEndereco$: BehaviorSubject<PageResult<Endereco>> = new BehaviorSubject<PageResult<Endereco>>(null);
  public enderecos: Endereco[];
  pageEndereco = 1;
  lengthEndereco = 0;
  pageSizeEndereco = 5;
  pageEventEndereco = null;
  pageSizeOptionsEndereco: number[] = [5, 10, 25];


  maskFone = {
    mask: '(00) {*}0000-0000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCep = {
    mask: '00000-000',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCpf = {
    mask: '000.000.000-00',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };

  maskCnpj = {
    mask: '00.000.000/0000-00',
    lazy: true,  // make placeholder always visible
    placeholderChar: '_'     // defaults to '_'
  };
  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };
  maskLower = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toLowerCase()
  };

  maskEmail = {
    mask: /^\S*@?\S*$/,
    prepare: (email: any) => email.toLowerCase()
  };

  cnpjReceitaWsResult: any = null;
  cnpjReceitaResult: any = null;
  cnpjReceitaResult2: any;
  cnpjReceitaResult3: Object;
  cnpjReceitaWsResult2: string;
  cadastroSelected: Cadastro;
  detailsMovto: MovtoDetails;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private snack: MatSnackBar,
    public dialogRef: MatDialogRef<CadastroTablePopupComponent>,
    private fb: FormBuilder,
    /////////////////////////////////////////////////////
    private cadastroService: CadastroService,
    private cadastroGrupoService: CadastroGrupoService,
    private cadastroMedidaService: TabelaMedidaService,
    private marcaService: MarcaService,
    private cadastroContatoService: CadastroContatoService,
    private fatDoctoCService: FatDoctoCService,
    private cadastroSerieNFService: SerieNFService,
    private condpgService: CondpgService,
    private portadorService: PortadorService,
    private veiculoService: VeiculoService,
    private cadastroFinancRpService: FinancRpService,
    private estadoService: EstadoService,
    private cidadeService: CidadeService,
    private grupoService: CadastroGrupoService,
    private cepService: CepService,
    private receitaWsService: ReceitaWsService,
    private layout: LayoutService,
    private loader: AppLoaderService,
    private confirmService: AppConfirmService
  ) {
    this.estados = new Estados().estados;
  }

  ngOnInit() {
    this.layoutConf = this.layout.layoutConf;
    this.buildItemForm(this.data.payload);
    this.pageObject$.subscribe(
      page => {
        if (page != null) {
          this.movtos = page.content;
          this.length = page.totalElements;
          this.pageSize = page.size;
          this.page = page.number;
          if (this.page === 1) {
            this.paginator.firstPage();
          }
        } else {
          this.movtos = [];
        }
      });

    this.pageObjectEndereco$.subscribe(
      page => {
        if (page != null) {
          this.enderecos = page.content;
          this.lengthEndereco = page.totalElements;
          this.pageSizeEndereco = page.size;
          this.pageEndereco = page.number;
          if (this.pageEndereco === 1) {
            this.paginatorEndereco.firstPage();
          }
        } else {
          this.enderecos = [];
        }
      });

  }

  buildItemForm(item: Cadastro) {
    this.cadastroSelected = item;
    
    console.log(JSON.stringify(item));
    
    this.itemForm = this.fb.group({
      id: [item.id],
      codigo: [item.codigo],
      uuid: [item.uuid],
      desativado: [item.desativado],
      razaoSocial: [item.razaoSocial, [Validators.required]],
      nomeFantasia: [item.nomeFantasia, [Validators.required]],
      telefone1: [item.telefone1, [Validators.required]],
      celular: [item.celular, [Validators.required]],
      cep: [item.cep, [Validators.required]],
      cadMun: [item.cadMun, [Validators.required]],
      cadCadastroGrupo: [item.cadCadastroGrupo, [Validators.required]],
      endereco: [item.endereco, [Validators.required]],
      numero: [item.numero, [Validators.required]],
      complemento: item.complemento,
      bairro: [item.bairro, [Validators.required]],
      pessoa: [item.pessoa, [Validators.required]],
      cpfCnpj: [item.pessoa === 'Fisica' ? item.cpf : item.inscricaoFederal, [Validators.required, Validacoes.validaCpfCnpj]],
      rgInscricao: [item.pessoa === 'Fisica' ? item.rg : item.inscricaoEstadual, [Validators.required]],
      inscricaoFederal: [item.inscricaoFederal],
      uf: [item.cadMun?.uf],

      cpf: [item.cpf],
      rg: [item.rg],
      inscricaoEstadual: [item.inscricaoEstadual],
      inscricaoCadPro: [item.inscricaoCadPro],
      dataNasc: [item.dataNasc, [Validators.required]],
      email: [item.email, [Validators.required]],
      cliente: [item.cliente || false],
      vendedor: [item.vendedor || false],
      produtor: [item.produtor || false],
      funcionario: [item.funcionario || false],
      trabalhador: [item.trabalhador || false],
      transportador: [item.transportador || false],
      motorista: [item.motorista || false],
      sindicato: [item.sindicato || false],

      lojaOnline: [item.lojaOnline || false],
      app: [item.app || false],

      urlApi: [item.urlApi],
      urlFotoLoja: [item.urlFotoLoja],
      urlLogo: [item.urlLogo]
    })

    this.itemDiretivasFatForm = this.fb.group({
      razaoSocial: [item.razaoSocial, [Validators.required]],
    })

    if (item?.id !== undefined) {
      this.cadastroService.getMovtoDetails(item.id.toString()).subscribe(val => {
        this.detailsMovto = val;
        // this.dataInicial = moment(this.detailsMovto.data_primeiro_lcto, 'YYYY-MM-DD').format('DD/MM/YYYY');
        // this.dataFinal = moment(this.detailsMovto.data_ultimo_lcto, 'YYYY-MM-DD').format('DD/MM/YYYY');
      });
    }

  }

  submit() {
    console.log(this.itemForm.value.endereco);
    this.itemForm.value.inscricaoFederal = this.itemForm.value.cpfCnpj;
    this.itemForm.value.cpf = this.itemForm.value.cpfCnpj;
    this.itemForm.value.rg = this.itemForm.value.rgInscricao;
    this.itemForm.value.inscricaoEstadual = this.itemForm.value.rgInscricao;
    this.dialogRef.close(this.itemForm.value)
  }

  onFocus(event: FocusEvent) {
    this.itemForm.get('cadMun').valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.isLoading = true),
        switchMap(value => ((typeof (value) === 'string') ?
          this.cidadeService.getCidadePageSearch(1,10,value) : new Observable<PageResult<Cidade>>())
          .pipe(
            finalize(() => this.isLoading = false),
          )
        )
      )
      .subscribe(cidades => this.cidades = cidades.content);
  }

  onSelectionChange(event: MatAutocompleteSelectedEvent): void {
    this.cadMun = event.option.value;
    this.itemForm.patchValue({ uf: this.cadMun.uf });
  }

  displayFn(cidade: Cidade) {
    if (cidade) {
      return `${cidade.municipio.trim()} - ${cidade.uf.trim()}`;
    }
  }

  /**
   * Grupo de cadastro
   */
  onFocusGrupo(event: FocusEvent) {
    this.itemForm.get('cadCadastroGrupo').valueChanges
      .pipe(
        debounceTime(500),
        tap(() => this.isLoadingGrupo = true),
        switchMap(value => ((typeof (value) === 'string') ?
          (value !== undefined && value !== '' ? this.grupoService.getGrupoPageSearch(1, 10, value) :
            this.grupoService.getGrupoPage(1, 10)) : new Observable<PageResult<CadastroGrupo>>())
          .pipe(
            finalize(() => this.isLoadingGrupo = false),
          )
        )
      )
      .subscribe(grupos => this.grupos = grupos.content);
  }

  ////////////////////////////////////////////

  onSelectionChangeGrupo(event: any): void {
    if (event.option.value !== undefined) {
      this.grupo = event.option.value;
    }
  }

  ////////////////////////////////////
  displayFnGrupo(grupo: CadastroGrupo) {
    if (grupo) {
      return `${grupo.id} - ${grupo.descricao.trim()}`;
    }
  }
///////////////////////////////////

  consultaCep(cep: string, ignoreEnd = false) {
    console.log('cep digitado: ' + cep);
    cep = cep.replace(/\D/g, '');
    if (cep != null && cep !== '') {
      this.cepService.consulta(cep).subscribe(dados => this.populaEndereco(dados, ignoreEnd));
    }
  }

  populaEndereco(dados: any, ignoreEnd = false) {
    console.log(dados);
    this.cidadeService.getCidadeIbge(dados.ibge).pipe(
      tap(() => this.isLoadingGrupo = true), catchError(_err => {
        console.log(_err);
        this.isLoadingCep = false;
        return of(null);
      })
    ).subscribe(c => {
      this.cadMun = c;
      if (ignoreEnd) {
        this.itemForm.patchValue({
          cadMun: this.cadMun,
          uf: this.cadMun.uf
        });
      } else {
        this.itemForm.patchValue({
          endereco: dados.logradouro,
          bairro: dados.bairro,
          cadMun: this.cadMun,
          uf: this.cadMun.uf
        });
      }
      this.isLoadingGrupo = false
    });
  }

  cnpjIsValid(cnpjValue: string) {
    return cnpj.isValid(cnpjValue);
  }

  consultaCNPJ(cnpjValue: string) {
    console.log('cnpj digitado: ' + cnpjValue);
    if (this.counter > 0 && this.counter < 20) {
      return;
    }
    this.loader.open();
    this.counter = 19;
    this.countDown = timer(0, this.tick)
      .subscribe(() => {
        if (this.counter <= 0) {
          this.counter = 20;
        } else if (this.counter < 20) {
          --this.counter;
        }
      });

    this.receitaWsService.consulta(cnpjValue)
      .subscribe(dados => {
        this.snack.open('Sucesso ao pesquisa o CNPJ!', 'OK', { duration: 5500 });
        this.cnpjReceitaWsResult = dados;
        this.cnpjReceitaWsResult2 = dados.status + ' - ' + JSON.stringify(dados.nome) + ' - ' + JSON.stringify((dados.atividade_principal));
        this.populaDadosCnpj(dados);
        this.loader.close();
      }, (err: HttpErrorResponse) => {
        this.loader.close();
        this.snack.open('Erro ao pesquisa o CNPJ!', 'ERRO', { duration: 5500 });
      });

  }

  consultaCNPJCert(cnpjValue: string) {
    this.cnpjReceitaResult2 = null;
    this.cnpjReceitaResult = null;

    // if (this.itemForm.value.uf === null ) {
    //   return;
    // }
    this.loader.open();
    this.cadastroService.getCadastroJuridicaCert(cnpjValue, this.itemForm.value.uf).subscribe(res => {
      // this.snack.open('Sucesso ao pesquisa o CNPJ!', 'OK', { duration: 5500 });
      this.cnpjReceitaResult2 = res.dados.motivo;
      this.cnpjReceitaResult = res;
      this.loader.close();
      if (res.dados.situacaoCadastral !== null && res.dados.situacaoCadastral.length > 1) {
        this.confirmService.confirm({
          title: 'Encontrado Mais de uma Inscricao Estadual',
          message: 'Selecione Inscrição estadual:', options: res.dados.situacaoCadastral.map(value => value.inscricaoEstadual)
        })
          .subscribe(val => {
            console.log(val);
            let inscricaoEstadual;
            if (val) {
              inscricaoEstadual = res.dados.situacaoCadastral.filter(insc => insc.inscricaoEstadual === val)[0];
              console.log('MAIS DE  1 , SELECIONADA INSC:');
              console.log(inscricaoEstadual);
            } else {
              inscricaoEstadual = res.dados.situacaoCadastral.map(insc => insc)[0];
              console.log('MAIS DE  1 , Ñ SELECIONADA INSC:');
              console.log(inscricaoEstadual);
            }
            this.cnpjReceitaResult2 = this.cnpjReceitaResult2 + ' - INCRICAO SELECIONADA:' + inscricaoEstadual.inscricaoEstadual;
            this.populaDadosCnpjReceita(inscricaoEstadual);

          })
      } else {
        const inscricaoEstadual = res.dados.situacaoCadastral.map(insc => insc)[0];
        this.cnpjReceitaResult2 = this.cnpjReceitaResult2 + ' - INCRICAO SELECIONADA:' + inscricaoEstadual.inscricaoEstadual;
        console.log('APENAS 1 INSC:');
        console.log(inscricaoEstadual);
        this.populaDadosCnpjReceita(inscricaoEstadual);
      }

      console.log(res);
    }, (err: HttpErrorResponse) => {
      this.loader.close();
      console.log(err)
      this.confirmService.confirm({
        title: 'Erro ao pesquisa o CNPJ!',
        message: 'DETALHES:' + err.error.status, error: true
      });

      this.snack.open('Erro ao pesquisa o CNPJ!', 'ERRO', { duration: 5500 });

    });
  }

  // {"versao":"2.00","ambiente":null,"dados":{"versaoAplicacao":"PR-v4_7_7","statusResposta":"112",
  // "motivo":"Consulta cadastro com mais de uma ocorrencia","uf":"PR","inscricaoEstadual":null,
  // "cnpj":"76639285000177","cpf":null,"dataHoraProcessamento":"2020-11-12T16:22:28.429",
  // "ufAutorizadora":"PR","situacaoCadastral":
  // [{"inscricaoEstadual":"9055005033","cnpj":"76639285000177","cpf":null,"uf":"PR","situacaoContribuinte":"HABILITADO",
  // "indicadorContribuinteNFe":"SEFAZ_NAO_FORNECE_ESSA_INFO","indicaodrContribuinteCTe":"SEFAZ_NAO_FORNECE_ESSA_INFO",
  // "razaoSocial":"FERRAGENS NEGRAO COMERCIAL LTDA","nomeFantasia":null,"regimeApuracaoICMSContribuinte":"Regime Diferenciado - Substituto Tributario","cnaePrincipalContribuinte":"4530702","dataInicioAtividade":"2011-02-01",
  // "dataUltimaModificacaoSituacaoCadastral":"2018-11-28","dataOcorrenciaBaixa":null,"inscricaoEstadualUnica":null,
  // "inscricaoEstadualAtual":null,
  // "endereco":{"logradouro":"RUA PROF ALGACYR MUNHOZ MADER","numero":"2800","complemento":null,"bairro":
  // "CIDADE INDUSTRIAL","codigoMunicipio":"4106902","descricaoMunicipio":"CURITIBA","cep":"81310020"}},
  // {"inscricaoEstadual":"9052972369","cnpj":"76639285000177","cpf":null,"uf":"PR","situacaoContribuinte":"HABILITADO","indicadorContribuinteNFe":"SEFAZ_NAO_FORNECE_ESSA_INFO","indicaodrContribuinteCTe":"SEFAZ_NAO_FORNECE_ESSA_INFO","razaoSocial":"FERRAGENS NEGRAO COMERCIAL LTDA","nomeFantasia":null,"regimeApuracaoICMSContribuinte":"Normal - Centralizador","cnaePrincipalContribuinte":"4672900","dataInicioAtividade":"2010-08-01","dataUltimaModificacaoSituacaoCadastral":"2020-09-28","dataOcorrenciaBaixa":null,"inscricaoEstadualUnica":null,"inscricaoEstadualAtual":null,"endereco":{"logradouro":"RUA PROF ALGACYR MUNHOZ MADER","numero":"2800","complemento":null,"bairro":"CIDADE INDUSTRIAL","codigoMunicipio":"4106902","descricaoMunicipio":"CURITIBA","cep":"81310020"}},
  // {"inscricaoEstadual":"1011739250","cnpj":"76639285000177","cpf":null,"uf":"PR","situacaoContribuinte":"NAO_HABILITADO","indicadorContribuinteNFe":"SEFAZ_NAO_FORNECE_ESSA_INFO","indicaodrContribuinteCTe":"SEFAZ_NAO_FORNECE_ESSA_INFO","razaoSocial":"FERRAGENS NEGRAO COMERCIAL LTDA","nomeFantasia":null,"regimeApuracaoICMSContribuinte":"Normal - Normal","cnaePrincipalContribuinte":"4672900","dataInicioAtividade":"1968-09-01","dataUltimaModificacaoSituacaoCadastral":"2007-02-12","dataOcorrenciaBaixa":"1995-09-01","inscricaoEstadualUnica":null,"inscricaoEstadualAtual":null,"endereco":{"logradouro":"RUA MONSENHOR CELSO","numero":"154","complemento":"9 ANDAR CJ.901","bairro":"CENTRO",
  // "codigoMunicipio":"4106902","descricaoMunicipio":"CURITIBA","cep":"80010150"}}]}}


  populaDadosCnpjReceita(dados: any) {
    this.itemForm.patchValue({
      rgInscricao: dados.inscricaoEstadual,
      razaoSocial: dados.razaoSocial,
      dataNasc: moment(dados.dataInicioAtividade, 'YYYY/MM/DD').toDate().toISOString().split('T')[0],
      uf: dados.uf,
      cep: dados.endereco.cep,
      endereco: dados.endereco.logradouro,
      numero: dados.endereco.numero,
      complemento: dados.endereco.complemento,
      bairro: dados.endereco.bairro,
    });
  }


  // {"atividade_principal":[{"text":"Obras de alvenaria","code":"43.99-1-03"}],
  // "data_situacao":"07/03/2014","tipo":"MATRIZ","nome":"ELDEVAN NERY 79035663934",
  // "uf":"PR","telefone":"(44) 9996-9599","qsa":[],"situacao":"ATIVA","bairro":"CENTRO",
  // "logradouro":"R ROCHA POMBO","numero":"561","cep":"87.260-000","municipio":"ARARUNA",
  // "porte":"MICRO EMPRESA","abertura":"07/03/2014","natureza_juridica":"213-5 - Empresário (Individual)"
  // ,"fantasia":"OXIGENIO OBRAS","cnpj":"19.834.693/0001-46","ultima_atualizacao":"2020-09-09T11:04:07.148Z",
  // "status":"OK","complemento":"","email":"","efr":"","motivo_situacao":"","situacao_especial":"","data_situacao_especial":
  // "","atividades_secundarias":[{"code":"00.00-0-00","text":"Não informada"}],
  // "capital_social":"10000.00","extra":{},"billing":{"free":true,"database":true}}

  populaDadosCnpj(dados: any) {
    console.log(dados);
    console.log(dados.abertura);

    let telefone1 = dados.telefone;

    let telefone2 = dados.telefone;

    const telefones = dados.telefone.split('/');
    if (telefones.length > 1) {
      telefone1 = telefones[0];
      telefone2 = telefones[1];
    }
    this.consultaCep(dados.cep, true);

    this.itemForm.patchValue({
      razaoSocial: dados.nome,
      nomeFantasia: dados.fantasia,
      telefone1: telefone1,
      celular: telefone2,
      cep: dados.cep,
      endereco: dados.logradouro,
      numero: dados.numero,
      complemento: dados.complemento,
      bairro: dados.bairro,
      dataNasc: moment(dados.abertura, 'DD/MM/YYYY').toDate().toISOString().split('T')[0],
      email: dados.email,
      uf: dados.uf
    });
  }

  setSelectedTabIndex(event: MatTabGroup) {
    this.selectedTabIndex = event.selectedIndex;
    if (event._tabs.toArray()[event.selectedIndex].textLabel.indexOf('Movimenta') > -1) {
      this.getPageMovto(this.page, this.pageSize, this.cadastroSelected.id, this.dataInicial, this.dataFinal);
    } else if (event._tabs.toArray()[event.selectedIndex].textLabel.indexOf('Endere') > -1) {
      this.getPageEndereco(this.pageEndereco, this.pageSizeEndereco, this.cadastroSelected.id);
    }
  }

  setPageSizeOptions(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.getPageMovto(event.pageIndex + 1, event.pageSize, this.cadastroSelected.id, this.dataInicial, this.dataFinal);
  }

  getPageMovto(page: number, pageSize: number, id: number, dataInicial: string, dataFinal: string) {
    if (id !== undefined) {
      this.cadastroService.getMovto(page, pageSize, this.selectedOrdem
        , this.selectedDirect, id.toString(), dataInicial, dataFinal).subscribe(val => { this.pageObject$.next(val) })
    }
  }

  reloadPageMovto() {
    this.page = 1;
    this.getPageMovto(this.page, this.pageSize, this.cadastroSelected.id, this.dataInicial, this.dataFinal);
  }

  setPageSizeOptionsEndereco(event: PageEvent) {
    this.pageSizeEndereco = event.pageSize;
    this.getPageEndereco(event.pageIndex + 1, event.pageSize, this.cadastroSelected.id);
  }

  getPageEndereco(page: number, pageSize: number, id: number) {
    if (id !== undefined) {
      this.cadastroService.getPageEndereco(page, pageSize, this.selectedOrdem
        , this.selectedDirect, id.toString()).subscribe(val => { this.pageObjectEndereco$.next(val) })
    }
  }

  reloadPageEndereco() {
    this.page = 1;
    this.getPageEndereco(this.page, this.pageSize, this.cadastroSelected.id);
  }

///////////////////////////////////
  addGrupo() {
    const dialogRef: MatDialogRef<any> = this.dialog.open(CadastroGrupoTablePopupComponent, {
      width: '1024px',
      disableClose: true,
      data: { title: 'Novo Grupo', payload: {} }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        this.loader.open();
        this.cadastroGrupoService.saveOrUpdate(res)
          .subscribe(data => {
            this.loader.close();
            this.snack.open('Cadastro de Grupo Salvo com sucesso!', 'OK', { duration: 5500 });
            this.grupo = data;
            this.itemForm.patchValue({ cadCadastroGrupo: data });
          }, (err: HttpErrorResponse) => {
            this.loader.close();
            this.snack.open('Erro ao savar o cadastro de Grupo!', 'ERRO', { duration: 5500 });
          })
      })
  }
//////////////////////////////////////////////////////////
  deleteEndereco(data: any = {}, isNew?) {
    this.confirmService.confirm({ message: `Deletar ${data?.endereco + '-' + data?.numero}?` })
      .subscribe(res => {
        if (res) {
          this.loader.open();
          this.cadastroService.deleteCadastroEndereco(data.id)
            .subscribe({
              next: data2 => {
                this.loader.close();
                this.confirmService.confirm({
                  title: data2.status ? 'Sucesso' : 'Erro', message: data2.status
                    ? `Endereço ${data?.endereco + '-' + data?.numero} deletado!`
                    : `Erro ao deletar ${data?.endereco + '-' + data?.numero} (há dependencias), tente desativar o cadastro!`, error: true
                });
                if (data2.status) {
                  this.getPageEndereco(1, this.pageSize, this.cadastroSelected.id);
                }
              },
              error: (error: HttpErrorResponse) => {
                this.loader.close();
                const message = error?.status === 404
                  ? `Endereço ${data?.endereco + '-' + data?.numero} não encontrado para exclusão.`
                  : `Erro ao deletar ${data?.endereco + '-' + data?.numero}.`;
                this.confirmService.confirm({ title: 'Erro', message, error: true });
              }
            })
        }
      })
  }

  popUpEndereco(data: any = {}, isNew?) {
    const title = isNew ? 'Novo Endereço' : 'Alterar Endereço';
    if (isNew) {
      data.cadastroId = this.cadastroSelected.id;
    }
    const dialogRef: MatDialogRef<any> = this.dialog.open(EnderecoPopupComponent, {
      width: '1024px',
      disableClose: true,
      data: { title: title, payload: data }
    })
    dialogRef.afterClosed()
      .subscribe(res => {
        if (!res) {
          return;
        }
        if ( this.instanceOfA(res)) {
          this.loader.open();
          this.cadastroService.saveOrUpdateEndereco(res)
            .subscribe(data2 => {
              this.loader.close();
              this.snack.open('Endereço Salvo com sucesso!', 'OK', { duration: 5500 });
              this.reloadPageEndereco();
            }, (err: HttpErrorResponse) => {
              this.loader.close();
              this.snack.open('Erro ao savar o endereço!', 'ERRO', { duration: 5500 });
            })
        } else {
          this.confirmService.confirm({
            title: 'Município informado incorretamente, verifique!', error: true
          });
        }
      })
  }


  instanceOfACidade = (p: any): p is Cidade => p.hasOwnProperty('id');


  instanceOfA(object: any): object is Endereco {

    return 'cadMun' in object &&  this.instanceOfACidade(object.cadMun) ;
  }

  close() {
    this.confirmService.confirm({ message: `Deseja realmente fechar? Poderá haver perda de dados.` })
      .subscribe(res => {
        if (res) {
          this.dialogRef.close(false);
        }
      });
  }


}
